/* eslint-disable react-hooks/exhaustive-deps */
// import * as wjcGrid from "@grapecity/wijmo.grid"
import dayjs, { Dayjs } from "dayjs"
import _ from "lodash"
import queryString from "query-string"
import React, { useEffect, useState } from "react"
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Container,
  Row,
  ToggleButton,
} from "react-bootstrap"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import DateInput from "../../../components/InputWrapper/DateInput"
import Spinner from "../../../components/Spinner"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import BusyoService from "../../../service/master/busyo/busyoService"
import HaisyaService from "../../../service/order/haisya/HaisyaService"
import {
  THaisyaListGetReq,
  T配車,
  T車輌乗務員,
} from "../../../service/order/haisya/THaisya"
import { TZyutyuHaisyaMihaisyaListGetReq } from "../../../service/order/zyutyuHaisya/TZyutyuHaisya"
import ZyutyuHaisyaService from "../../../service/order/zyutyuHaisya/zyutyuHaisyaService"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import {
  MihaisyaListContext,
  MihaisyaSearchContext,
  CalenderSearchContext,
  SearchConditionContext,
  SelectCellContext,
  ZyomuinListContext,
} from "./HaisyaContext"
import HaisyaHanreiModal from "./HaisyaModal/HaisyaHanreiModal"
import HaisyaRegisterModal from "./HaisyaModal/HaisyaRegisterModal"
import MihaisyaCard from "./MihaisyaCard"
import DayTab from "./Tabs/DayTab"
import MonthlyTab, { focusTargetId } from "./Tabs/MonthlyTab"
import OneDayTab from "./Tabs/OneDayTab"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const ItemType = {
  配車: "配車",
  配車日単位: "配車日単位",
} as const

export const eTabs = { "1日": "1", "3日": "2", "7日": "3", 月間: "4" } as const

/**
 * 配送順設定用関数
 * @param a
 * @param b
 * @returns
 */
export const sort配送順 = <T extends { 配送順?: number }>(a: T, b: T) => {
  const a配送順 = a.配送順 ?? 0
  const b配送順 = b.配送順 ?? 0
  return a配送順 - b配送順
}

/**
 * remで表現
 */
const mihaisyaWidth = 35

/**
 * 配車入力
 * @returns
 */
const HaisyaRegister = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch: AppDispatch = useDispatch()

  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )
  const { yokueigyobiStr: 翌営業日 } = useSelector(
    (state: RootState) => state.date
  )

  //#region [state]

  const [tabIndex, setTabIndex] = useState<string>("1")

  const [selectKey, setSelectKey] = useState("")
  const [chip, setChip] = useState<string>("1")

  // 検索用
  const [preSearchCondition, setPreSearchCondition] =
    useState<THaisyaListGetReq>({} as THaisyaListGetReq)
  const [displaySearchCondition, setDisplaySearchCondition] = useState<any>()
  const [isSearching, setIsSearching] = useState(false)
  const [isCalenderSearching, setIsCalenderSearching] = useState(false)
  const [isMihaisyaSearching, setIsMihaisyaSearching] = useState(false)
  const [乗務員List, set乗務員List] = useState<T車輌乗務員[]>([])
  const [未配車List, set未配車List] = useState<T配車[]>([])

  const [検索用積日, set検索用積日] = useState<string | null | undefined>(
    翌営業日
  )

  const [選択積日, set選択積日] = useState<string>()
  const [選択車輌, set選択車輌] = useState<T車輌乗務員>()
  const [選択配車IDList, set選択配車IDList] = useState<number[]>([])

  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  // ログインユーザーの部所を初期表示
  const [運行部所コード, set運行部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)

  // comboBox
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  const [isShowHaisyaRegisterModal, setIsShowHaisyaRegisterModal] =
    useState<boolean>(false)
  const [isSelect未配車, setIsSelect未配車] = useState<boolean>(false)

  const [isShowHaisyaHanreiModal, setIsShowHaisyaHanreiModal] = useState(false)
  //#endregion

  //#region [method]

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: Partial<THaisyaListGetReq> = queryString.parse(location.search)
    //URLに合わせて上部を変更
    // TODO:ユーザーの運行部所で初期表示
    set運行部所コード(query.運行部所コード ?? userInfo.部所コード ?? "")
    set検索用積日(query.積日)
    return query as THaisyaListGetReq
  }

  /**
   * 表示用検索条件作成
   * @param queryString
   */
  const createDisplaySearchCondition = (
    searchCondition: THaisyaListGetReq
  ): any | undefined => {
    const 部所Data = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.運行部所コード
    )
    return {
      積日: util.date.format(searchCondition.積日),
      部所: 部所Data && `${部所Data?.部所コード} ${部所Data?.部所名}`,
    }
  }

  /**
   * 配車用searchCondition作成
   *
   * @param {THaisyaListGetReq} searchCondition
   * @return {*}  {TZyutyuHaisyaMihaisyaListGetReq}
   */
  const createSearchCondition = (searchCondition?: THaisyaListGetReq) => {
    const 配車searchCondition: Partial<THaisyaListGetReq> = searchCondition ?? {
      運行部所コード: 運行部所コード ?? "",
      積日: 検索用積日 ?? "",
    }
    const 積日Dayjs = dayjs(検索用積日)
    // 現在のタブ状態を確認、それに合わせて配車の取得範囲を変更
    let 積日From: Dayjs
    let 積日To: Dayjs
    switch (tabIndex) {
      case eTabs["1日"]:
        積日From = 積日Dayjs.subtract(1, "day")
        積日To = 積日Dayjs
        break
      case eTabs["3日"]:
        積日From = 積日Dayjs.subtract(1, "day")
        積日To = 積日Dayjs.add(1, "day")
        break
      case eTabs["7日"]:
        積日From = 積日Dayjs.subtract(1, "day")
        積日To = 積日Dayjs.add(5, "day")
        break
      case eTabs["月間"]:
        積日From = 積日Dayjs.startOf("M")
        積日To = 積日Dayjs.endOf("M")
        break
      default:
        積日From = 積日Dayjs
        積日To = 積日Dayjs
        break
    }
    // 前後七日も取得する
    配車searchCondition.取得積日From = 積日From.subtract(7, "day").format("")
    配車searchCondition.取得積日To = 積日To.add(7, "day").format("")

    return 配車searchCondition as THaisyaListGetReq
  }

  /**
   * 未配車用searchCondition作成
   *
   * @param {THaisyaListGetReq} searchCondition
   * @return {*}  {TZyutyuHaisyaMihaisyaListGetReq}
   */
  const create未配車SearchCondition = (
    searchCondition: THaisyaListGetReq
  ): TZyutyuHaisyaMihaisyaListGetReq => {
    const 配車searchCondition: TZyutyuHaisyaMihaisyaListGetReq = {
      運行部所コード: searchCondition.運行部所コード ?? "",
      積日From: searchCondition.積日,
      積日To: "",
    }
    const 積日Dayjs = dayjs(searchCondition.積日)
    // 現在のタブ状態を確認、それに合わせて未配車の取得範囲を変更
    switch (tabIndex) {
      case eTabs["1日"]:
        配車searchCondition.積日To = 積日Dayjs.format("")
        break
      case eTabs["3日"]:
        配車searchCondition.積日From = 積日Dayjs.subtract(1, "day").format("")
        配車searchCondition.積日To = 積日Dayjs.add(1, "day").format("")
        break
      case eTabs["7日"]:
        配車searchCondition.積日From = 積日Dayjs.subtract(1, "day").format("")
        配車searchCondition.積日To = 積日Dayjs.add(5, "day").format("")
        break
      case eTabs["月間"]:
        配車searchCondition.積日To = 積日Dayjs.endOf("M").format("")
        break
      default:
        break
    }

    return 配車searchCondition
  }

  /**
   * 全体検索
   */
  const search = async (searchCondition?: THaisyaListGetReq) => {
    setIsSearching(true)
    dispatch(clearAlert()) // アラートを非表示に
    // 検索前にキャッシュクリアの意味合いで空を入れる
    set乗務員List([])
    set未配車List([])

    let currentSearchCondition: THaisyaListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    if (currentSearchCondition == null) return
    setPreSearchCondition({ ...currentSearchCondition })

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    const 配車searchCondition: TZyutyuHaisyaMihaisyaListGetReq =
      create未配車SearchCondition(currentSearchCondition)

    try {
      const haisyaService = new HaisyaService()
      const zyutyuHaisyaService = new ZyutyuHaisyaService()
      const 乗務員res = await haisyaService.getList(currentSearchCondition)
      const 配車res = await zyutyuHaisyaService.getMihaisyaList(
        配車searchCondition
      )

      //表示用の検索条件を作成
      setDisplaySearchCondition(
        createDisplaySearchCondition(currentSearchCondition)
      )

      set乗務員List([...乗務員res.data])
      set未配車List(
        _.orderBy(配車res.data, ["積日", "荷主コード", "受注伝票番号"])
      )
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false)
    }
  }

  /**
   * カレンダー検索用メソッド
   * @returns
   */
  const calenderSearch = async (searchCondition?: THaisyaListGetReq) => {
    setIsCalenderSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    try {
      const 乗務員res = await new HaisyaService().getList(
        searchCondition &&
          searchCondition.積日 != null &&
          searchCondition.運行部所コード != null
          ? searchCondition
          : preSearchCondition
      )

      set乗務員List([...乗務員res.data])
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsCalenderSearching(false)
    }
  }

  /**
   * 未配車検索用メソッド
   * @returns
   */
  const mihaisyaSearch = async (searchCondition?: THaisyaListGetReq) => {
    setIsMihaisyaSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    const 配車searchCondition: TZyutyuHaisyaMihaisyaListGetReq =
      create未配車SearchCondition(
        searchCondition &&
          searchCondition.積日 != null &&
          searchCondition.運行部所コード != null
          ? searchCondition
          : preSearchCondition
      )
    try {
      const 配車res = await new ZyutyuHaisyaService().getMihaisyaList(
        配車searchCondition
      )

      set未配車List(
        _.orderBy(配車res.data, ["積日", "荷主コード", "受注伝票番号"])
      )
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsMihaisyaSearching(false)
    }
  }
  /**
   * セル選択時イベント
   */
  const setSelectData = (props: {
    積日?: string
    車輌乗務員?: T車輌乗務員
    受注配車?: T配車[]
  }) => {
    set選択積日(props.積日)
    set選択車輌(props.車輌乗務員)
    props.受注配車 && set選択配車IDList(props.受注配車.map((z) => z.受注配車ID))
  }

  //#endregion

  //#region [effect]

  useEffect(() => {
    dispatch(画面ロック開始())
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (部所isLoadEnded) {
      let querySearchCondition: THaisyaListGetReq | undefined = undefined

      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        querySearchCondition = queryParse()

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        if (userInfo.運行部所フラグ === 1) {
          set運行部所コード(userInfo.部所コード)
          querySearchCondition = {
            運行部所コード: userInfo.部所コード,
            積日: 検索用積日 ?? "",
          }
          search(querySearchCondition).finally(() => {
            dispatch(画面ロック解除())
          })
        } else {
          dispatch(画面ロック解除())
        }
      }
    }
  }, [部所isLoadEnded])

  useEffect(() => {
    if (tabIndex === "4") {
      const target = document.getElementById(focusTargetId)
      target && target.scrollIntoView()
    }
  }, [tabIndex, 乗務員List])

  useEffect(() => {
    if (
      preSearchCondition &&
      preSearchCondition.積日 != null &&
      preSearchCondition.運行部所コード != null
    ) {
      search()
    }
  }, [tabIndex])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">配車入力</span>
        </Col>
      </Row>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <ZyomuinListContext.Provider
          value={{
            車輌乗務員List: 乗務員List,
            set車輌乗務員List: (v) => {
              set乗務員List([...v])
            },
          }}>
          <SearchConditionContext.Provider value={preSearchCondition}>
            <MihaisyaListContext.Provider value={{ 未配車List, set未配車List }}>
              <CalenderSearchContext.Provider value={calenderSearch}>
                <SelectCellContext.Provider
                  value={{
                    chip,
                    setChip,
                    selectKey,
                    setSelectKey,
                    setSelectData,
                    isModalShow: isShowHaisyaRegisterModal,
                    setIsModalShow: (v) => {
                      setIsSelect未配車(false)
                      setIsShowHaisyaRegisterModal(true)
                    },
                  }}>
                  <MihaisyaSearchContext.Provider value={mihaisyaSearch}>
                    <Row className="d-flex">
                      <DndProvider backend={HTML5Backend}>
                        <div
                          style={{
                            width: `calc(100% - ${mihaisyaWidth}rem)`,
                            minWidth: `calc(var(--min-width) - var(--leftMenu-open-width) - ${
                              mihaisyaWidth + 5
                            }rem)`,
                          }}>
                          {/* 検索結果カード */}
                          <Card className="h-65rem min-h-65rem max-h-65rem">
                            <Spinner
                              searching={isSearching || isCalenderSearching}
                              inModal={true}></Spinner>
                            <Card.Body>
                              <Container fluid>
                                <Row>
                                  <Col>
                                    <ul className="list-cmn d-flex">
                                      <li className="list-cmn">
                                        <div className="w-10rem">
                                          <DateInput
                                            id="積日"
                                            placeholder="検索日"
                                            isRequired={true}
                                            value={検索用積日}
                                            showHoliday={true}
                                            defaultValue={翌営業日}
                                            setValue={(v) => {
                                              set検索用積日(v)
                                            }}></DateInput>
                                        </div>
                                      </li>
                                      <li className="list-cmn list-padding">
                                        <div className="w-20rem">
                                          <ComboBox.Busyo
                                            placeholder="運行部所"
                                            isLoadEnded={部所isLoadEnded}
                                            setIsLoadEnded={set部所isLoadEnded}
                                            isAllSelect={false}
                                            isRequired={true}
                                            listFilter={(item) =>
                                              item.運行部所フラグ === 1
                                            }
                                            itemsSource={部所ItemSource}
                                            selectedValue={運行部所コード}
                                            setSelectedValue={(v) => {
                                              set運行部所コード(v)
                                            }}
                                            ComboBox={部所ComboBox}
                                            setComboBox={
                                              set部所ComboBox
                                            }></ComboBox.Busyo>
                                        </div>
                                      </li>

                                      <li className="list-cmn list-padding align-middle">
                                        <Button
                                          type="submit"
                                          disabled={isSearching}
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            e.preventDefault()
                                            search()
                                          }}>
                                          <FontAwesomeIcon icon={faSearch} />
                                          検索
                                        </Button>
                                      </li>
                                    </ul>
                                  </Col>
                                  <Col className="text-end">
                                    <ButtonGroup className="mb-3">
                                      {[
                                        { name: "1日", value: "1" },
                                        { name: "3日", value: "2" },
                                        { name: "7日", value: "3" },
                                        { name: "月間", value: "4" },
                                      ].map((radio, idx, arr) => (
                                        <ToggleButton
                                          key={idx}
                                          id={`radio-${radio.name}`}
                                          type="radio"
                                          variant={"outline-success"}
                                          name="radio"
                                          size="lg"
                                          className="fs-4"
                                          value={radio.value}
                                          checked={tabIndex === radio.value}
                                          onChange={(e) =>
                                            setTabIndex(e.currentTarget.value)
                                          }>
                                          {radio.name}
                                        </ToggleButton>
                                      ))}
                                    </ButtonGroup>
                                  </Col>
                                  {/* <Col className="text-end">
                            <Button
                              type="button"
                              onClick={searchClear}
                              variant="secondary"
                              className="text-end">
                              検索条件をクリアする
                            </Button>
                          </Col> */}
                                </Row>
                                <Row>
                                  <Col className="text-nowrap">
                                    <DisplaySearchConditionLabel
                                      displaySearchCondition={
                                        displaySearchCondition
                                      }
                                    />
                                  </Col>
                                  <Col>
                                    <div className="d-flex text-nowrap text-center">
                                      <div className="p-1">凡例：</div>
                                      <div
                                        style={{
                                          background:
                                            "var(--tumibi-zyutyu-haisya-card)",
                                          marginRight: "0.5rem",
                                        }}
                                        className="p-1 border border-2 rounded">
                                        積卸車両
                                      </div>
                                      <div
                                        style={{
                                          backgroundColor:
                                            "var(--zyomuin-change)",
                                          marginRight: "0.5rem",
                                        }}
                                        className="p-1 border border-2 rounded">
                                        乗務員変更
                                      </div>
                                      <div
                                        style={{
                                          backgroundColor:
                                            "var(--parent-bunkatu)",
                                          marginRight: "0.5rem",
                                        }}
                                        className="p-1 w-25 border border-2 rounded">
                                        積車両
                                      </div>
                                      <div
                                        style={{
                                          backgroundColor:
                                            "var(--child-bunkatu)",
                                          marginRight: "0.5rem",
                                        }}
                                        className="p-1 w-25 border border-2 rounded">
                                        卸車両
                                      </div>
                                      <div
                                        style={{
                                          backgroundColor: "var(--tumi-only)",
                                          marginRight: "0.5rem",
                                        }}
                                        className="p-1 w-25 border border-2 rounded">
                                        積のみ
                                      </div>
                                      <div
                                        style={{
                                          backgroundColor: "var(--orosi-only)",
                                          marginRight: "0.5rem",
                                        }}
                                        className="p-1 w-25 border border-2 rounded">
                                        卸のみ
                                      </div>
                                    </div>
                                  </Col>
                                  <Col className="text-end">
                                    <ButtonGroup className="mb-3">
                                      {[
                                        { name: "標準", value: "1" },
                                        { name: "食事", value: "2" },
                                      ].map((radio, idx, arr) => (
                                        <ToggleButton
                                          key={idx}
                                          id={`chip-radio-${radio.name}`}
                                          type="radio"
                                          name="chip-radio"
                                          size="sm"
                                          variant={
                                            idx % 2
                                              ? "outline-primary"
                                              : "outline-danger"
                                          }
                                          value={radio.value}
                                          checked={chip === radio.value}
                                          onChange={(e) =>
                                            setChip(e.currentTarget.value)
                                          }>
                                          {radio.name}
                                        </ToggleButton>
                                      ))}
                                    </ButtonGroup>
                                    <Button
                                      className="mb-3 ms-4 d-none"
                                      onClick={(e) => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        setIsShowHaisyaHanreiModal(true)
                                      }}>
                                      凡例
                                    </Button>
                                  </Col>
                                </Row>
                                <Row
                                  className={
                                    乗務員List.length > 0 ? "" : "d-none"
                                  }>
                                  <Col>
                                    <div className="d-block">
                                      {tabIndex === eTabs["1日"] && (
                                        <OneDayTab></OneDayTab>
                                      )}
                                      {tabIndex === eTabs["3日"] && (
                                        <DayTab between={3}></DayTab>
                                      )}
                                      {tabIndex === eTabs["7日"] && (
                                        <DayTab between={7}></DayTab>
                                      )}
                                      {tabIndex === eTabs.月間 && (
                                        <MonthlyTab></MonthlyTab>
                                      )}
                                    </div>
                                  </Col>
                                </Row>
                              </Container>
                            </Card.Body>
                          </Card>
                        </div>
                        <div style={{ width: `${mihaisyaWidth}rem` }}>
                          <Card className="h-65rem min-h-65rem max-h-65rem">
                            <Spinner
                              searching={isSearching || isMihaisyaSearching}
                              inModal={true}></Spinner>
                            <Card.Body>
                              <div className="h-2rem">
                                <Button
                                  disabled={
                                    preSearchCondition.運行部所コード == null
                                  }
                                  onClick={(_e) => {
                                    set選択車輌(undefined)
                                    set選択配車IDList([])
                                    setSelectData({
                                      受注配車: [],
                                    })
                                    setIsSelect未配車(true)
                                    setIsShowHaisyaRegisterModal(true)
                                  }}>
                                  未配車 受注登録
                                </Button>
                              </div>
                              {未配車List.length > 0 ? (
                                <div className="max-h-58rem overflow-auto border border-1">
                                  {未配車List.map((未配車) => (
                                    <MihaisyaCard
                                      displayTab={tabIndex}
                                      onDoubleClick={(_e) => {
                                        set選択車輌(undefined)
                                        set選択配車IDList([未配車.受注配車ID])
                                        setSelectData({
                                          受注配車: [未配車],
                                        })
                                        setIsSelect未配車(true)
                                        setIsShowHaisyaRegisterModal(true)
                                      }}
                                      key={未配車.受注配車ID}
                                      haisyaInfo={未配車}></MihaisyaCard>
                                  ))}
                                </div>
                              ) : (
                                <>未配車状態の受注は存在しません。</>
                              )}
                            </Card.Body>
                          </Card>
                        </div>
                      </DndProvider>
                    </Row>

                    <HaisyaRegisterModal
                      isShow={isShowHaisyaRegisterModal}
                      setIsShow={setIsShowHaisyaRegisterModal}
                      syaryoZyomuin={選択車輌 ?? ({} as T車輌乗務員)}
                      tumibi={選択積日}
                      zyutyuHaisyaList={選択配車IDList}
                      isMihaisya={isSelect未配車}></HaisyaRegisterModal>
                  </MihaisyaSearchContext.Provider>
                </SelectCellContext.Provider>
              </CalenderSearchContext.Provider>
            </MihaisyaListContext.Provider>
          </SearchConditionContext.Provider>
        </ZyomuinListContext.Provider>
      </Container>
      <HaisyaHanreiModal
        isShow={isShowHaisyaHanreiModal}
        setIsShow={setIsShowHaisyaHanreiModal}
        title="カード凡例"></HaisyaHanreiModal>
    </Container>
  )
}

export default HaisyaRegister
